import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
import Cookies from 'js-cookie';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import CookieConsent from './components/CookieConsent/CookieConsent';
import { initGA } from './services/googleAnalytics';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const AppWithAnalytics = () => {
  const [consent, setConsent] = React.useState(Cookies.get('user-consent'));

  React.useEffect(() => {
    const handleCookieChange = () => {
      setConsent(Cookies.get('user-consent'));
    };
    window.addEventListener('cookie-change', handleCookieChange);
    return () => {
      window.removeEventListener('cookie-change', handleCookieChange);
    };
  }, []);

  const app = (
    <HashRouter>
      <App />
    </HashRouter>
  );

  if (consent === 'true') {
    return (
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY || ''}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: false,
        }}
      >
        {app}
      </PostHogProvider>
    );
  }

  return app;
};

root.render(
  <React.StrictMode>
    <CookieConsent onAccept={initGA}>
      <AppWithAnalytics />
    </CookieConsent>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();